"use client";

import { useTranslations } from "next-intl";
import { ProductsGrid } from "@/features/products/ui/components/ProductsGrid";
import { useFavProductStore } from "@/features/user/ui/store";
import { useRouter } from "@/i18n/navigation";
import { NotFound } from "@/lib/client/components/NotFound";
import { BackNav, Container } from "@/ui";

export const WishListContainer = () => {
  const router = useRouter();
  const notFoundT = useTranslations("not_found");
  const { favProducts } = useFavProductStore();
  return (
    <Container>
      <BackNav onBack={() => router.back()} />
      {favProducts && favProducts.length > 0 ? (
        <ProductsGrid products={favProducts} />
      ) : (
        <NotFound description={notFoundT("favorite")} />
      )}
    </Container>
  );
};
